module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    staticStyle: {
      "border-top": "5px solid #ff0000"
    },
    attrs: {
      "id": "info-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$t('messageEnquesta')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('messageEnquesta2')))]), _vm._v(" "), _c('h6', [_c('a', {
    staticStyle: {
      "font-size": "1em",
      "color": "#444"
    },
    attrs: {
      "href": "https://forms.office.com/Pages/ResponsePage.aspx?id=V5S73HJB-UO3rUQwD03qJrfhkDr8AkdPjYrm9xa4He9UQzBTTlVDT1pPRk9PQlQzM0QzTThOWElSVi4u&lang=ca-Ca",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('messageEnquesta3')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11190fce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/components/info-modal/info-modal.vue
// module id = 289
// module chunks = 0